const MAX_DAILY_PROMPTS = 3;
const STORAGE_KEY = 'daily_prompt_usage';

interface UsageData {
    date: string; // YYYY-MM-DD
    count: number;
}

export function checkDailyLimit(): boolean {
    const today = new Date().toISOString().split('T')[0];
    const stored = localStorage.getItem(STORAGE_KEY);

    if (!stored) return true;

    try {
        const data: UsageData = JSON.parse(stored);
        if (data.date !== today) {
            // Reset for new day (implicitly valid)
            return true;
        }
        return data.count < MAX_DAILY_PROMPTS;
    } catch {
        return true;
    }
}

export function incrementDailyLimit() {
    const today = new Date().toISOString().split('T')[0];
    const stored = localStorage.getItem(STORAGE_KEY);

    let currentCount = 0;

    if (stored) {
        try {
            const data: UsageData = JSON.parse(stored);
            if (data.date === today) {
                currentCount = data.count;
            }
        } catch (e) {
            console.error("Failed to parse daily limit usage", e);
        }
    }

    const newData: UsageData = {
        date: today,
        count: currentCount + 1
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(newData));
}

export function getRemainingDailyPrompts(): number {
    const today = new Date().toISOString().split('T')[0];
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return MAX_DAILY_PROMPTS;
    try {
        const data: UsageData = JSON.parse(stored);
        if (data.date !== today) return MAX_DAILY_PROMPTS;
        return Math.max(0, MAX_DAILY_PROMPTS - data.count);
    } catch {
        return MAX_DAILY_PROMPTS;
    }
}
